import React from "react";
import { Nine  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Nine} chartData={chartData} />;
};

export default ShreeDay;
